export const SET_ANCHOR_EL = 'CacheDownloadManager/SET_ANCHOR_EL'
export const SET_TYPE = 'CacheDownloadManager/SET_TYPE'
export const SET_PROGRESS = 'CacheDownloadManager/SET_PROGRESS'
